import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { type GTMEventGlycerinDisplayOverlay } from '@packages/tracking/src/types/events';
import { type GlycerinDisplayBasePayload } from '@packages/tracking/src/types/payloads';

export const useEcoLabelItemTracking = () => {
  const dispatchGTMEvent = useTracking();

  const trackEcoLabelDisplayOverlayed = (label: GlycerinDisplayBasePayload['label']) => {
    dispatchGTMEvent<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: 'dv-service-layer-eco-label-item',
        label,
      },
    });
  };

  return {
    trackEcoLabelDisplayOverlayed,
  };
};
